import { Alert, Collapse } from "@mui/material";
import { useStore } from "../../hooks/store";
import { useEffect, useState } from "react";

export default function AlertProvider({ children }) {
  const appStore = useStore();

  const { open, text, status } = appStore.alert;

  const handleClose = () => appStore.closeAlert();
  useEffect(() => {
    if (open)
      setTimeout(() => {
        appStore.closeAlert();
      }, 3000);
  }, [open]);

  return (
    <>
      {children}

      {open && (
        <Alert
          variant="standard"
          severity={status}
          style={{ zIndex: 9999 }}
          onClose={handleClose}>
          {text}
        </Alert>
      )}
    </>
  );
}
